export default __webpack_public_path__ + "static/banner-1-3a29641da97ea7e1981c87da90bfb3ff.jpg";